export enum CanvasComposite {
  Lighter = 'lighter',
}
